import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const submitRSVP = (payload) => axios.post(`${API}/rsvp`, payload);

export const adminHeaders = (token) => ({ headers: { "X-Admin-Token": token } });
export const getStats = (token) => axios.get(`${API}/rsvp/stats`, adminHeaders(token));
export const getRSVPs = (token) => axios.get(`${API}/rsvp`, adminHeaders(token));
export const exportURL = () => `${API}/rsvp/export`;
